<template>
  <div class="longImagePage">
    <el-card style="margin: 30px;">
      <div style="display: flex;align-items: center">
        <el-button size="small" type="primary" @click="searchBtn">刷新</el-button>
        <el-button size="small" type="success" @click="addBtn">新增</el-button>
        <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
      </div>

      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="tableData"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%;margin-top: 30px"
      >
        <el-table-column
            type="selection"
            align="center"
            width="55">
        </el-table-column>
        <el-table-column label="封面图" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center">
              <el-image
                  style="width: 160px; height: 80px"
                  :src="scope.row.cover_url"
                  :preview-src-list="scope.row.cover_urlList">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="长图" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center">
              <el-image
                  style="width: 50px; height: 100px"
                  :src="scope.row.oss_url"
                  :preview-src-list="scope.row.oss_urlList">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title" align="center"></el-table-column>
        <el-table-column label="摘要" width="230" align="center">
          <template slot-scope="scope">
            <a-tooltip placement="right" trigger="click">
              <template slot="title">
                {{scope.row.zhaiyao}}
              </template>
              <span style="width:210px;height:70px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 3;overflow : hidden;">{{ scope.row.zhaiyao }}</span>
            </a-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="广告类型" width="100" align="center">
          <template slot-scope="scope">
            <div>
              {{scope.row.media_type === 1 ? '图片':''}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="240"
        >
          <template slot-scope="scope">
            <el-button
                @click="copy"
                type="primary"
                size="mini"
                class="btns"
                :data-clipboard-text="'https://www.weiguanzixun.com/zdyPage?id=' + scope.row.id"
            >复制链接</el-button>
            <el-button size="small" type="success" @click="editBtn(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="deleteBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalElements">
      </el-pagination>

    </el-card>


    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="120px"
      >
        <el-form-item label="封面图" prop="coverUrl" class="coverUrl">
          <el-upload
              :before-upload="beforeCoverAvatarUpload"
              :on-success="handleCoverAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.coverUrl" :src="ruleForm.coverUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="长图" prop="ossUrl" class="ossUrl">
          <el-upload
              :before-upload="beforeOssAvatarUpload"
              :on-success="handleOssAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.ossUrl" :src="ruleForm.ossUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="广告类型" prop="mediaType">
          <el-select style="width: 300px" size="small" v-model="ruleForm.mediaType" placeholder="请选择广告类型">
            <el-option
                v-for="item in [{name:'图片',id:1}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title" style="width: 300px" size="small" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="摘要" prop="zhaiyao">
          <el-input v-model="ruleForm.zhaiyao" style="width: 300px" type="textarea" :rows="4" size="small" placeholder="请输入摘要"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

  </div>
</template>

<script>
import {baseURL} from "@/api/config";
import Clipboard from "clipboard";

export default {
  data() {
    return {
      areaCode: null,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      totalElements: 0,
      addDialogState: false,
      dialogTitle: '',
      uploadApiUrl: '',
      ruleForm: {
        id: null,
        coverUrl: '',
        ossUrl: '',
        mediaType: null,
        title: '',
        zhaiyao: '',
      },
      rules: {
        coverUrl: [{required: true, message: "请选择封面图", trigger: "blur"}],
        ossUrl: [{required: true, message: "请选择长图", trigger: "blur"}],
        mediaType: [{required: true, message: "请选择广告类型", trigger: "blur"}],
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        zhaiyao: [{required: true, message: "请输入摘要", trigger: "blur"}],
      },
      simpleDelete: false,
      deleteId:null,
      deleteDialogState: false,
      multipleSelection:[]
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadAdFile'
    this.getList()
  },
  methods: {
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    searchBtn() {
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList()
    },
    addBtn() {
      this.dialogTitle = '新增广告'
      this.ruleForm = {
        id: null,
        coverUrl: '',
        ossUrl: '',
        mediaType: null,
        title: '',
        zhaiyao: '',
      }
      this.addDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    editBtn(row){
      this.dialogTitle = '编辑广告'
      this.ruleForm.id = row.id
      this.ruleForm.coverUrl = row.cover_url
      this.ruleForm.ossUrl = row.oss_url
      this.ruleForm.mediaType = row.media_type
      this.ruleForm.title = row.title
      this.ruleForm.zhaiyao = row.zhaiyao
      this.addDialogState = true
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/zidingyiPage/delZidingyiByIds", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/zidingyiPage/delZidingyiByIds", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      }
    },
    getList() {
      this.postAxios("/zidingyiPage/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.success) {
          res.content.forEach((item) => {
            item.cover_urlList = []
            item.oss_urlList = []
            if (item.cover_url) {
              item.cover_urlList.push(item.cover_url)
            }
            if (item.oss_url) {
              item.oss_urlList.push(item.oss_url)
            }
          })
          this.tableData = res.content
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
          this.totalElements = 0
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleCoverAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.coverUrl = res.entity;
      }
    },
    beforeCoverAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleOssAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.ossUrl = res.entity;
      }
    },
    beforeOssAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增广告') {
            this.postAxios("/zidingyiPage/insert", this.ruleForm).then(res=>{
              this.$message.success("添加成功!");
              this.addDialogState = false
              this.getList()
            })
          } else {
            this.postAxios("/zidingyiPage/update", this.ruleForm).then(res=>{
              this.$message.success("修改成功!");
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown__item{
  width: 300px;
}
.coverUrl{
/deep/ .avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
  height: 100px;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

/deep/ .avatar {
  width: 200px;
  height: 100px;
  display: block;
}
}
.ossUrl{
  /deep/ .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 200px;
  }

  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    border: 1px dashed #d9d9d9;
  }

  /deep/ .avatar {
    width: 100px;
    height: 200px;
    display: block;
  }
}
</style>
